import request from '@/utils/request'

// 查询发货预测列
export function listShipmentForecast (query) {
  return request({
    url: '/scp/scpSopShipmentForecast/listShipmentForecast',
    method: 'get',
    params: query
  })
}
// 供应列表-净值仓更新
export function listUpdateNetSubInventory (data) {
    return request({
      url: '/scp/scpSupplyDefault/listUpdateNetSubInventory',
      method: 'post',
      data: data
    })
  }
  // 发货预测新建页面查询参数版本
export function listBaseVersion (data) {
  return request({
    url: '/scp/scpSopShipmentForecast/listBaseVersion',
    method: 'get',
    data: data
  })
}
  // 默认最新销售预测的名称和版本
  export function getLastSalesForecast (data) {
    return request({
      url: '/scp/scpSopShipmentForecast/getLastSalesForecast',
      method: 'get',
      data: data
    })
  }
    // 新建发货预测
  export function createShipmentForecast (data) {
      return request({
        url: '/scp/scpSopShipmentForecast/createShipmentForecast',
        method: 'post',
        data: data
      })
    }
// 通过id查询发货预测基本信息
  export function apiShipmentForecastById (id) {
    return request({
      url: `/scp/scpSopShipmentForecast/getShipmentForecastById/${id}`,
      method: 'get'
    })
  }
  // 删除发货预测
  export function apiDeleteShipmentForecast (id) {
    return request({
      url: `/scp/scpSopShipmentForecast/deleteShipmentForecast/${id}`,
      method: 'get'
    })
  }
  // 关闭发货预测
  export function apiCloseShipmentForecast (id) {
    return request({
      url: `/scp/scpSopShipmentForecast/close/${id}`,
      method: 'get'
    })
  }
  // 更新发货预测+预测列表
  export function apiUpdateShipmentForecast (data) {
    return request({
      url: `/scp/scpSopShipmentForecast/updateShipmentForecast`,
      method: 'post',
      data: data
    })
  }
  // 滚动业绩报表
  export function apiListRollingReport (data) {
    return request({
      url: `/scp/scpSopShipmentForecast/listRollingReport`,
      method: 'post',
      data: data
    })
  }
  // 发货预测汇总查询
  export function apiListShipmentForecastSum (query) {
    return request({
      url: `/scp/scpSopShipmentForecast/listShipmentForecastSum`,
      method: 'get',
      params: query
    })
  }
   // 发货预测详情查询
    export function apilistShipmentForecastDetail (data) {
      return request({
        url: `/scp/scpSopShipmentForecast/listShipmentForecastDetail`,
        method: 'post',
        data: data
      })
    }
  // 启动计算
  export function apiStartCalculate (id) {
    return request({
      url: `/scp/scpSopShipmentForecast/startCalculate/${id}`,
      method: 'get'
    })
  }
    // 停止计算
    export function apiStopCalculate (id) {
      return request({
        url: `/scp/scpSopShipmentForecast/stopCalculate/${id}`,
        method: 'get'
      })
    }
    // 发布发货预测
    export function apiPublishShipmentForecast (id) {
      return request({
        url: `/scp/scpSopShipmentForecast/publishShipmentForecast/${id}`,
        method: 'get'
      })
    }
    // 发布发货预测
    export function apiCreateAndStartShipmentForecast (data) {
      return request({
        url: `/scp/scpSopShipmentForecast/createAndStartShipmentForecast`,
        method: 'post',
        data: data
      })
    }
        // 事业部
  export function apiListBusiness () {
    return request({
        url: `/scp/scpSopShipmentForecast/listBusiness`,
         method: 'get'
       })
    }
      // 查询发货预测新建页面信任度
  export function apiGetCredibility () {
         return request({
            url: `/scp/scpSopShipmentForecast/getCredibility`,
            method: 'get'
          })
     }
      // 查询未发取消比例
   export function apiGetCancellationRation (query) {
        return request({
           url: `/scp/scpSopShipmentForecast/getCancellationRation`,
           method: 'get',
           params: query
         })
    }
   // 查询当月销售目标完成占比
   export function apiGetSalesTargetRation (query) {
    return request({
       url: `/scp/scpSopShipmentForecast/getSalesTargetRation`,
       method: 'get',
       params: query
     })
  }
     // 发货预测新建页面查询参数版本
     export function apiListBaseVersion (query) {
      return request({
         url: `/scp/scpSopShipmentForecast/listBaseVersion`,
         method: 'get',
         params: query
       })
    }
